import { k as d, e as b, f as v, w } from "./cage-B9sdzDdT.js";
import { c as l, t as h } from "./index-rfWRAczx.js";
import { createRequire as S } from "module";
import { g as P } from "./utils-S4B18cwO.js";
const M = S(import.meta.url), u = M("isolated-vm"), j = (s, a, c, e, t) => new Promise((r, o) => {
  const i = b(c);
  if (v(i))
    return o(`Response parsing failed: ${i.left}`);
  const n = t.global, { pw: m, testRunStack: y, updatedEnvs: f } = w(a), g = P({
    ...m,
    response: i.right
  });
  n.setSync("serializedAPIMethods", g, { copy: !0 }), n.setSync("atob", atob), n.setSync("btoa", btoa), n.setSync("ivm", u);
  const x = `
    const pw = new Proxy(serializedAPIMethods, {
      get: (pwObj, pwObjProp) => {
        // pw.expect(), pw.env, etc.
        const topLevelEntry = pwObj[pwObjProp]

        // If the entry exists and is a function
        // pw.expect(), pw.test(), etc.
        if (topLevelEntry && topLevelEntry.typeof === "function") {
          // pw.test() just involves invoking the function via "applySync()"
          if (pwObjProp === "test") {
            return (...args) => topLevelEntry.applySync(null, args)
          }

          // pw.expect() returns an object with matcher methods
          return (...args) => {
            // Invoke "pw.expect()" and get access to the object with matcher methods
            const expectFnResult = topLevelEntry.applySync(
              null,
              args.map((expectVal) => {
                if (typeof expectVal === "object") {
                  if (expectVal === null) {
                    return null
                  }

                  // Only arrays and objects stringified here should be parsed from the "pw.expect()" method definition
                  // The usecase is that any JSON string supplied should be preserved
                  // An extra "isStringifiedWithinIsolate" prop is added to indicate it has to be parsed

                  if (Array.isArray(expectVal)) {
                    return JSON.stringify({
                      arr: expectVal,
                      isStringifiedWithinIsolate: true,
                    })
                  }

                  return JSON.stringify({
                    ...expectVal,
                    isStringifiedWithinIsolate: true,
                  })
                }

                return expectVal
              })
            )

            // Matcher methods that can be chained with "pw.expect()"
            // pw.expect().toBe(), etc
            if (expectFnResult.typeof === "object") {
              // Access the getter that points to the negated matcher methods via "{ accessors: true }"
              const matcherMethods = {
                not: expectFnResult.getSync("not", { accessors: true }),
              }

              // Serialize matcher methods for use in the isolate context
              const matcherMethodNames = [
                "toBe",
                "toBeLevel2xx",
                "toBeLevel3xx",
                "toBeLevel4xx",
                "toBeLevel5xx",
                "toBeType",
                "toHaveLength",
                "toInclude",
              ]
              matcherMethodNames.forEach((methodName) => {
                matcherMethods[methodName] = expectFnResult.getSync(methodName)
              })

              return new Proxy(matcherMethods, {
                get: (matcherMethodTarget, matcherMethodProp) => {
                  // pw.expect().not.toBe(), etc
                  const matcherMethodEntry = matcherMethodTarget[matcherMethodProp]

                  if (matcherMethodProp === "not") {
                    return new Proxy(matcherMethodEntry, {
                      get: (negatedObjTarget, negatedObjprop) => {
                        // Return the negated matcher method defn that is invoked from the test script
                        const negatedMatcherMethodDefn = negatedObjTarget.getSync(negatedObjprop)
                        return negatedMatcherMethodDefn
                      },
                    })
                  }

                  // Return the matcher method defn that is invoked from the test script
                  return matcherMethodEntry
                },
              })
            }
          }
        }

        // "pw.env" set of API methods
        if (typeof topLevelEntry === "object" && pwObjProp !== "response") {
          return new Proxy(topLevelEntry, {
            get: (subTarget, subProp) => {
              const subLevelProperty = subTarget[subProp]
              if (
                subLevelProperty &&
                subLevelProperty.typeof === "function"
              ) {
                return (...args) => subLevelProperty.applySync(null, args)
              }
            },
          })
        }

        return topLevelEntry
      },
    })

      ${s}
    `;
  e.compileScript(x).then((p) => p.run(t)).then(() => {
    r({
      tests: y,
      envs: f
    });
  }).catch((p) => {
    o(p);
  });
}), A = (s, a, c) => d(
  h(
    async () => {
      const e = new u.Isolate(), t = await e.createContext();
      return { isolate: e, context: t };
    },
    (e) => `Context initialization failed: ${e}`
  ),
  l(
    ({ isolate: e, context: t }) => d(
      h(
        async () => j(
          s,
          a,
          c,
          e,
          t
        ),
        (r) => `Script execution failed: ${r}`
      ),
      l(
        (r) => h(
          async () => (await e.dispose(), r),
          (o) => `Isolate disposal failed: ${o}`
        )
      )
    )
  )
);
export {
  A as runPostRequestScriptWithIsolatedVm
};
